<div appGlobalDragDrop (filesDropped)="onFilesDropped($event)" (dragging)="onDragging($event)"
  [class.dragging]="isDragging">
  <!-- Drop indicator -->
  @if(isDragging && claims?.IsFinanceManager){<div class="ds-overlay__panel"></div>}
  @if(isDragging && claims?.IsFinanceManager){<div class="stmtdate-modal dragable-popup-content_container ">
    <img class="upload-icon" src="assets/svg-icons/icons/upload-cloud.svg">
    <div class="d-flex flex-column align-items-center gap-6 text-center">
      <h6 class="upload-title">{{ 'drag_drop_cc_statement' | translate }}</h6>
      <p class="upload_desc">{{ 'drop_cc_statement_anywhere' | translate }}</p>
      <div class="upload-error_container ">
        <p class="upload-error_text">{{ 'ensure_file_has_card_number' | translate }}</p>
      </div>
    </div>
    <hr class="hr-border-disabled">
    <p class="upload-info_text">{{ "supported_formats" | translate }}</p>
    <div class="d-flex gap-8">
      <div class="eod-tag eod-tag--lg tag-accent no-icon">
        <p class="tag-text">.{{'pdf' | translate}}</p>
      </div>
      <div class="eod-tag eod-tag--lg tag-accent no-icon">
        <p class="tag-text">.{{'csv' | translate}}</p>
      </div>
      <div class="eod-tag eod-tag--lg tag-accent no-icon">
        <p class="tag-text">.{{'xls' | translate}}</p>
      </div>
      <div class="eod-tag eod-tag--lg tag-accent no-icon">
        <p class="tag-text">.{{'xlsx' | translate}}</p>
      </div>
    </div>
  </div>}
  <router-outlet></router-outlet>
  <app-alert-panel [data]="alertPanelModel" (callbackEvent)="closeAlertPanel($event)"></app-alert-panel>
  <app-alert-new-panel [data]="alertNewPanelModel" (callbackEvent)="closeNewAlertPanel($event)"></app-alert-new-panel>
  <logging-panel></logging-panel>

  <app-alert-panel [data]="alertPanelModelForReload"
    (callbackEvent)="closeAlertPanelForReload($event)"></app-alert-panel>

  <div class="overLayDiv active" *ngIf="showAppUpdatePanel"></div>
  <div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column" *ngIf="showAppUpdatePanel">
      <header class="panel-header">
        <div class="viewDemo title-and-video">
          <h2>{{ "label_alert" | translate }}</h2>
        </div>
      </header>
      <div class="block">
        <h6 class="info-text">
          <i class="fas fa-info-circle"></i>
          <span>{{ "we_just_updated_this_page" | translate }}</span>
        </h6>
        <h6 class="info-text">
          <i class="fas fa-info-circle"></i>
          <span>{{ "you_will_not_be_able_to_refresh" | translate }} </span>
        </h6>

        <h6 class="info-text">
          <i class="fas fa-info-circle eod-text-danger"></i>
          <span class="eod-text-danger">{{ "please_refresh_the_page" | translate }}
          </span>
        </h6>
      </div>
      <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
        <div>
          <button class="btn eod-btn-primary" (click)="onRefreshClick()">
            {{ "refresh" | translate }}
          </button>
        </div>
      </footer>
    </div>
  </div>

  <!-- Scanning document modal -->
  <div class="ds-overlay__panel" *ngIf="(isCreditCardScanInProgress && !isScanModalDismissed) || (isImportSubmitting && !isImportModalDismissed)"></div>
  <div class="scanning-modal gap-16" *ngIf="isCreditCardScanInProgress && !isScanModalDismissed">
    <button (click)="fnDismissScanModal()"
      style="position:absolute;top:12px;right:12px;background:none;border:none;cursor:pointer;line-height:1;padding:4px;z-index:100000"><img
        [src]="ICONS.CLOSE" style="width:18px;height:18px" /></button>
    <ul class="ds-info-text w-95pc">
      <li class="icon-xl --icon-ai --info text-md">{{ 'scanning_document' | translate }}</li>
      <li>
        <div class="d-flex flex-column w-100pc">
          <div class="d-flex flex-column">
            <p class="paragraph-12">{{ 'scanning_extracting_spend_details' | translate }}</p>
            <p class="paragraph-10 text-placeholder">{{ 'scanning_ai_analyzing' | translate }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <!-- Importing Transactions modal -->
  <div class="scanning-modal gap-16" *ngIf="isImportSubmitting && !isAssigningPhase && !isImportModalDismissed">
    <button (click)="fnDismissImportModal()" class="close-btn">
      <img [src]="ICONS.CLOSE" />
    </button>
    <ul class="ds-info-text w-95pc">
      <li class="--icon-ai --info text-md">{{ 'cc_importing_transactions' | translate }}</li>
      <li>
        <div class="d-flex flex-column gap-16 w-100pc">
          <div class="d-flex flex-column gap-2px">
            <p class="paragraph-12">{{ 'cc_reading_validating_transactions' | translate }}</p>
            <p class="paragraph-10 text-placeholder">{{ 'cc_scanning_ai_analyzing' | translate }}</p>
          </div>
          <div class="d-flex flex-column gap-8">
            <div class="progress-primary">
              <ngb-progressbar id="progressBarInput" [value]="importProgress" [max]="100"
                [animated]="true"></ngb-progressbar>
            </div>
            <p class="paragraph-12 text-placeholder">
              <span class="text-secondary">Importing {{importingTransactionCount}} Transactions</span>
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <!-- Assigning Transactions to Claimants modal -->
<div class="scanning-modal gap-16" *ngIf="isAssigningPhase && !isImportModalDismissed">
    <button (click)="fnDismissImportModal()" class="close-btn">
      <img [src]="ICONS.CLOSE" />
    </button>
    <ul class="ds-info-text w-95pc">
      <li class="icon-xl --icon-ai --info text-md">{{ 'assigning_transactions' | translate }}</li>
      <li>
        <div class="d-flex flex-column gap-16 w-100pc">
          <div class="d-flex flex-column gap-2px">
            <p class="paragraph-12">{{ 'assigning_transactions_to_claimants' | translate }}</p>
            <p class="paragraph-10 text-placeholder">{{ 'ai_mapping_transaction_claimant' | translate }}</p>
          </div>
          <div class="assigning-transactions__claimant">
            <img src="../assets/svg-icons/icons/user-duotone.svg" alt="">
            <div>
              <p class="title">{{ currentAssigningFullName }}</p>
              <p class="sec-text">{{ currentAssigningCardDisplay }}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <!-- ── Statement Date Modals ─────────────────────────────────────────── -->


  <!-- 1. Confirm Statement Date -->
  <div class="ds-overlay__panel" *ngIf="stateDateStep !== 'none'"></div>
  <div class="stmtdate-modal" *ngIf="stateDateStep === 'confirm'">

    <div class="statement__header gap-0">
      <h6>{{ 'confirm_statement_date' | translate }}</h6>
    </div>
    <div class="statement__header gap-0">
      <h6>{{ detectedStatementDate | date:'dd-MMMM-yyyy' }}</h6>
      <p>{{ 'extracted_from_imported_statement' | translate }}</p>
    </div>
    <div class="statement__header gap-0">
      <p>{{ 'please_check_confirm_statement_date' | translate }}</p>
    </div>
    <div class="stmtdate-modal__actions">
      <button class="btn btn-primary-outline btn-primary-outline--md btn-block" (click)="fnOpenAmendCalendar()">{{
        'no_amend_it' | translate
        }}</button>
      <button class="btn btn-primary btn-primary--md btn-block mt-0" (click)="fnConfirmStatementDate()">{{ 'yes_confirm'
        | translate }}</button>
    </div>

  </div>

</div>

<!-- 2. Date Confirmed -->
<div class="stmtdate-modal stmtdate-modal--confirmed" *ngIf="stateDateStep === 'confirmed'">
  <div class="statement__header">
    <div class="d-flex align-items-start gap-8">
      <div class="stmtdate-modal__confirmed-icon">
        <img src="../assets/svg-icons/icons/check.svg" alt="confirmed">
      </div>
      <h6 class="stmtdate-modal__title">{{ 'date_confirmed' | translate }}</h6>
    </div>
  </div>
  <div class="statement__header gap-0">
    <h6>{{ detectedStatementDate | date:'dd-MMM-yyyy' }}</h6>
    <p>{{ 'statement_date_added_successfully' | translate }}</p>
  </div>
</div>

<!-- 3. Amend Statement Date (calendar) -->
<div class="stmtdate-modal stmtdate-modal--calendar" *ngIf="stateDateStep === 'amend'">
  <div class="statement__header">
    <h6>{{ 'amend_statement_date' | translate }}</h6>
    <p>{{ 'select_correct_date_from_calendar' | translate }}</p>
    <a class="stmtdate-reset-link eod-link-primary" *ngIf="isAmendDateChanged" (click)="fnResetToOriginal()">{{ 'reset_to_original' |
      translate }}</a>
  </div>
  <div class="stmtdate-calendar">
    <div class="stmtdate-calendar__nav">
      <button class="stmtdate-calendar__nav-btn" (click)="fnPrevMonth()">
        <img src="../assets/svg-icons/icons/chevron-left.svg" alt="Previous Month">
      </button>
      <p class="stmtdate-calendar__month-label">{{ calendarMonthLabel }}</p>
      <button class="stmtdate-calendar__nav-btn" (click)="fnNextMonth()">
        <img src="../assets/svg-icons/icons/chevron-right.svg" alt="Next Month">
      </button>
    </div>
    <div class="stmtdate-calendar__header">
      <p *ngFor="let d of calendarDayNames">{{ d }}</p>
    </div>
    <div class="stmtdate-calendar__body">
      <div class="stmtdate-calendar__week" *ngFor="let week of calendarWeeks">
        <div *ngFor="let day of week" class="stmtdate-calendar__day"
          [class.selected]="fnIsSameDay(day, selectedCalendarDate)" [class.empty]="!day"
          [class.future]="fnIsFutureDay(day)" (click)="fnSelectCalendarDate(day)">
          {{ day ? day.getDate() : '' }}
        </div>
      </div>
    </div>
  </div>
  <div class="stmtdate-modal__actions">
    <button class="btn btn-primary-outline btn-primary-outline--md btn-block" (click)="fnCancelAmend()">{{
      'label_cancel' | translate
      }}</button>
    <button class="btn btn-primary btn-primary--md btn-block mt-0" [disabled]="!selectedCalendarDate"
      (click)="fnSaveStatementDate()">{{ 'save_date' | translate }}</button>
  </div>
</div>

<!-- 4. Statement Date Not Detected (calendar, no cancel) -->
<div class="stmtdate-modal stmtdate-modal--calendar stmtdate-modal--not-detected"
  *ngIf="stateDateStep === 'not-detected'">
  <div class="statement__header">
    <h6 class="text-error">{{ 'statement_date_not_detected' | translate }}</h6>
    <p class="text-placeholder">{{ 'statement_date_not_detected_msg' | translate }}</p>
  </div>
  <div class="stmtdate-calendar">
    <div class="stmtdate-calendar__nav">
      <button class="stmtdate-calendar__nav-btn" (click)="fnPrevMonth()">
        <img src="../assets/svg-icons/icons/chevron-left.svg" alt="Previous Month">
      </button>
      <p class="stmtdate-calendar__month-label">{{ calendarMonthLabel }}</p>
      <button class="stmtdate-calendar__nav-btn" (click)="fnNextMonth()">
        <img src="../assets/svg-icons/icons/chevron-right.svg" alt="Next Month">
      </button>
    </div>
    <div class="stmtdate-calendar__header">
      <p *ngFor="let d of calendarDayNames">{{ d }}</p>
    </div>
    <div class="stmtdate-calendar__body">
      <div class="stmtdate-calendar__week" *ngFor="let week of calendarWeeks">
        <div *ngFor="let day of week" class="stmtdate-calendar__day"
          [class.selected]="fnIsSameDay(day, selectedCalendarDate)" [class.empty]="!day"
          [class.future]="fnIsFutureDay(day)" (click)="fnSelectCalendarDate(day)">
          <!-- <span> -->
          {{ day ? day.getDate() : '' }}
          <!-- </span> -->
        </div>
      </div>
    </div>
  </div>
  <div class="stmtdate-modal__actions stmtdate-modal__actions--full w-100pc">
    <button class="btn btn-primary btn-primary--md btn-block" [disabled]="!selectedCalendarDate"
      (click)="fnSaveStatementDate()">{{ 'save_date' | translate }}</button>
  </div>
</div>
<!-- ────────────────────────────────────────────────────────────────────── -->

<!-- ── Amount Direction Confirmation Side Panel ──────────────────────── -->
<div class="ds-overlay__panel" *ngIf="showAmountDirectionModal"></div>
<div id="rightSidePanel" class="ds-side__panel w-40pc" *ngIf="showAmountDirectionModal">
  <header class="ds-panel__header">
    <div class="title__video">
      <h2 class="title">{{ 'important' | translate }}</h2>
    </div>
    <div class="ds-panel__right-button">
      <button type="button" class="ds-panel__Close" (click)="showAmountDirectionModal= false">
        <img src="../assets/svg-icons/icons/close.svg" alt="close" />
      </button>
    </div>
  </header>
  <div class="ds-panel__body">
    <div class="border-content__area">
      <div class="statement__header">
        <h6 class="title-16">{{ 'how_should_we_read_statement' | translate }}</h6>
        <p class="f-12 text-placeholder fw-500">{{ 'we_noticed_most_amounts_are' | translate }} <strong>{{ (amtDirMajorityNegative ? 'negative' : 'positive') | translate }}</strong>. {{ 'help_us_understand' | translate }}</p>
      </div>
      <div class="primary-info-container">
        <ul class="ds-info-text">
          <li class="--icon-ai --info fw-600 icon-xl">{{ 'smart_detection' | translate }}</li>
          <li class="no-icon"><div>{{ 'based_on_transactions_detected' | translate }} <strong>{{ (amtDirMajorityNegative ? 'negative' : 'positive') | translate }} {{ 'amounts_likely_expenses' | translate }}</strong>. {{ 'preselected_option_tip' | translate }}</div>
          </li>
        </ul>
      </div>
      <div class="border-content__area gap-8">
        <div class="form-check ds-eod-radio ds-eod-radio--md">
          <input class="form-check-input is-primary" type="radio" name="formRadios1" id="formRadios1"
            [checked]="amountDirectionOption === 1" (click)="amountDirectionOption = 1">
          <label class="form-check-label" for="formRadios1">
            <p class="label-text"><span class="text-danger"></span> {{ 'negative_values_money_out' | translate }}</p>
            <p class="helper-text"><span class="text-success"></span> {{ 'positive_values_money_in' | translate }}</p>
          </label>
        </div>
        <div class="d-flex align-items-center gap-8">
          <hr class="hr-border-muted">{{ 'or' | translate }}
          <hr class="hr-border-muted">
        </div>
        <div class="form-check ds-eod-radio ds-eod-radio--md">
          <input class="form-check-input is-primary" type="radio" name="formRadios2" id="formRadios2"
            [checked]="amountDirectionOption === 2" (click)="amountDirectionOption = 2">
          <label class="form-check-label" for="formRadios2">
            <p class="label-text"><span class="text-success"></span> {{ 'positive_values_money_out' | translate }}</p>
            <p class="helper-text"><span class="text-danger"></span> {{ 'negative_values_money_in' | translate }}</p>
          </label>
        </div>
      </div>
      <div class="white-info-container --borderless">
        <div class="eod-checkbox eod-checkbox--md form-check m-0">
          <input type="checkbox" id="chkRememberChoice" class="form-check-input is-primary" [(ngModel)]="rememberAmountDirectionChoice">
          <label class="form-check-label" for="chkRememberChoice">{{ 'remember_choice_future_imports' | translate }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="ds-panel__footer">
    <button class="btn btn-primary-outline btn-primary-outline--md btn-block" (click)="fnReviewManually()">{{
      'review_manually' | translate }}</button>
    <button class="btn btn-primary btn-primary--md btn-block mt-0" (click)="fnConfirmAmountDirectionAndImport()">{{
      'confirm_and_continue' | translate }}</button>
  </div>
</div>

<!-- ── Smart Import Wizard (PDF Statement Checker) ──────────────────────────── -->
<smart-import-wizard
  *ngIf="showSmartImportWizard"
  [analysisResult]="smartImportAnalysisResult"
  [organisationName]="claims?.OrgName"
  [submitting]="smartImportSubmitting"
  [submitError]="smartImportSubmitError"
  (cancelled)="fnSmartImportCancelled()"
  (submitClassification)="fnSmartImportSubmit($event)"
></smart-import-wizard>

<!-- ── Review Manually Side Panel ────────────────────────────────────────── -->
<div class="ds-overlay__panel" *ngIf="showReviewManuallyModal"></div>

<div id="rightSidePanel" class="ds-side__panel w-60pc" *ngIf="showReviewManuallyModal">
  <header class="ds-panel__header">
    <div class="title__video">
      <h2 class="title">{{ 'review' | translate }}</h2>
    </div>
    <div class="ds-panel__right-button">
      <button type="button" class="ds-panel__Close" (click)="fnReviewGoBack()">
        <img src="../assets/svg-icons/icons/close.svg" alt="close" />
      </button>
    </div>
  </header>
  <div class="ds-panel__body">
    <div class="block mt-2 d-flex flex-column gap-16">
      <div class="statement__header">
        <h6 class="title-16">{{ 'review_your_transactions' | translate }}</h6>
        <p class="f-12 text-placeholder fw-500">{{ 'check_transaction_toggle_tip' | translate }}</p>
      </div>
      <div>
        <div *ngIf="reviewSelectedCount > 0"
          class="secondary-info-container d-flex justify-content-between align-items-center gap-8 flex-row bg-white"
          style="border-radius: 4px 4px 0 0; border-bottom: none;">
          <p [ngClass]="{'text-link': !(reviewSelectedCount === 0), 'text-disabled': reviewSelectedCount === 0 }">
            {{ reviewSelectedCount === 0 ? ('no_transactions_selected' | translate) :
            (reviewSelectedCount > 1 ? ('transactions_selected' | translate: {count: reviewSelectedCount}) : ('transaction_selected' | translate: {count: reviewSelectedCount})) }}</p>
          <div class="d-flex align-items-center gap-8">
            <button class="btn btn-danger-outline btn-danger-outline--sm" (click)="fnReviewMarkSelected(true)">{{ 'mark_as_expense' | translate }}</button>
            <button class="btn btn-success-outline btn-success-outline--sm" (click)="fnReviewMarkSelected(false)">{{ 'mark_as_payments_refunds' | translate }}</button>
            <button class="btn btn-primary btn-primary--sm" (click)="fnReviewDeselectAll()">{{ 'deselect_all' | translate }}</button>
          </div>
        </div>
        <div class="heightCalc-20" style="overflow: hidden;">
          <grid #reviewGridRef [columns]="reviewGridColumnDefs" [data]="reviewFilteredTransactions"
            [gridConfigItems]="reviewGridConfigItems" (onCellClick)="fnReviewCellClick($event)"
            (onCheckAll)="fnReviewOnCheckAll($event)" [dropdownList]="reviewTypeDropdown"
            (filterChanged)="fnReviewTypeFilterChange($event)">
          </grid>
        </div>
      </div>
    </div>
  </div>
  <div class="ds-panel__footer">
    <button class="btn btn-primary-outline btn-primary-outline--md btn-block w-35pc" (click)="fnReviewGoBack()">
      {{ 'go_back' | translate }}</button>
    <button class="btn btn-primary btn-primary--md btn-block mt-0" (click)="fnReviewConfirmImport()">{{ 'confirm_import_all_transactions' | translate }}</button>
  </div>
</div>


<!-- z-99999: the import summary is opened from inside other panels — including
     the Imported Transactions panel created further down this template — so it
     has to stack above them rather than relying on DOM order -->
<div class="overLayDiv active z-99999" *ngIf="isCreditCardImportInProgress"></div>
<div id="rightSideBar">
  <div class="rightSidePanel active w-40pc z-99999" *ngIf="isCreditCardImportInProgress">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2>{{ "import_summary" | translate }}</h2>
      </div>
      <div class="panel-left-btn">
        <button type="button" class="btn eod-btn-outline-warning" (click)="closeCreditCardImportSummary()">
          {{ "close" | translate }}
        </button>
      </div>
    </header>
    <div style="display: flex">
      <div class="w-100pc">
        <div class="block mt-2">
          <div class="border-content__area gap-16 mb-3" *ngIf="isCreditCardImportInProgress">
            <p class="text-link fw-600 f-14">{{ "importing_credit_card_statement" | translate}}</p>
            <table class="table rounded-corners mb-0">
              <tbody>
                <tr>
                  <td>{{"label_total_transactions" | translate }}</td>
                  <td class="text-right fw-600 text-info">{{dragnDropCardImportResponse?.TotalTransactions }}
                  </td>
                </tr>
                <tr>
                  <td>{{"importing_now" | translate }}</td>
                  <td class="text-right fw-600 text-info">{{dragnDropCardImportResponse?.ImportingNow }}</td>
                </tr>
                <tr>
                  <td>{{"remaining" | translate }}</td>
                  <td class="text-right fw-600 text-info">{{dragnDropCardImportResponse?.Remaining }}</td>
                </tr>
                <tr>
                  <td>{{"cc_dashboard_label_claimants" | translate }}</td>
                  <td class="text-right fw-600 text-info">{{dragnDropCardImportResponse?.Claimants }}</td>
                </tr>
                <tr>
                  <td>{{"attaching_receipts_with_expense" | translate }}</td>
                  <td class="text-right fw-600 text-info">{{dragnDropCardImportResponse?.AttachingWithReceipts }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="border-content__area gap-16 mb-3"
            *ngIf=" isCreditCardImportInProgress && (dragnDropCardImportResponse?.DuplicateTransactions > 0 || dragnDropCardImportResponse?.MissingReferenceNumbers > 0)">
            <p class="text-error fw-600 f-14">{{ "not_imported" | translate }}</p>
            <table class="table rounded-corners mb-0">
              <tbody>
                <tr>
                  <td>{{ "duplicate_transactions" | translate }}</td>
                  <td class="text-right fw-600 text-info text-underline cursor-pointer"
                    (click)="showDuplicateTransactions()">{{
                    dragnDropCardImportResponse?.DuplicateTransactions }}</td>
                </tr>
                <tr>
                  <td>{{ "missing_reference_number" | translate }}</td>
                  <td class="text-right fw-600 text-info text-underline cursor-pointer"
                    (click)="showMissingTransactions()">{{
                    dragnDropCardImportResponse?.MissingReferenceNumbers
                    }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="primary-info-container">
            <ul class="ds-info-text --icon-info --link">
              <li><span class="text-link fw-600">{{ 'important' | translate }}:</span>&nbsp;{{ 'auto_generate_reference_number_tip' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Duplicate Transactions Detected — every transaction in the dropped file has
     already been imported, so nothing is imported and the user is shown which
     earlier files they came from. -->
<div class="ds-overlay__panel" *ngIf="showDuplicateTransactionsPanel"></div>
<div id="rightSidePanel" class="ds-side__panel w-40pc" *ngIf="showDuplicateTransactionsPanel">
  <header class="ds-panel__header">
    <div class="title__video">
      <h2 class="title">{{ "duplicate_transactions_detected" | translate }}</h2>
    </div>
    <div class="ds-panel__right-button">
      <button type="button" class="ds-panel__Close" (click)="fnCloseDuplicateTransactionsPanel()">
        <img src="../assets/svg-icons/icons/close.svg" alt="close" />
      </button>
    </div>
  </header>

  <div class="ds-panel__body">
    <div class="border-content__area">
      <div class="error-info-container">
        <ul class="ds-info-text">
          <li class="--icon-alert-circle --alert fw-600">
            {{ "all_transactions_already_exist" | translate }}
          </li>
          <li class="no-icon">
            <div>
              {{ "duplicate_transactions_detected_msg_start" | translate }}
              {{ duplicateTransactionCheck?.totalTransactions }}
              {{ "duplicate_transactions_detected_msg_end" | translate }}
            </div>
          </li>
        </ul>
      </div>

      <div class="statement__header">
        <h6 class="title-16">
          {{ "where_these_transactions_already_exist" | translate }} ({{ duplicateSourceCount }})
        </h6>
      </div>

      <!-- card-radio-button is column flex, so the row has to live inside it -->
      <div class="card-radio-button mb-2" *ngFor="let source of duplicateTransactionCheck?.sources">
        <div class="d-flex align-items-center justify-content-between gap-2 w-100pc">
          <div class="d-flex align-items-center gap-2">
            <i class="fas fa-file-alt eod-text-primary f-18"></i>
            <div>
              <h6 class="m-0 f-14 fw-600">{{ source.fileName }}</h6>
              <small class="d-block text-placeholder fw-500">
                {{ "imported_on" | translate }}
                {{ source.importDateTime | date: "dd-MMM-yyyy hh:mm a" }}
              </small>
            </div>
          </div>
          <button type="button" class="btn btn-primary-outline btn-primary-outline--sm"
            (click)="fnViewDuplicateSource(source)">
            {{ "label_view" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="ds-panel__footer">
    <button class="btn btn-primary-outline btn-primary-outline--md btn-block"
      (click)="fnOpenImportHistoryFromDuplicates()">
      {{ "import_history" | translate }}
    </button>
    <button class="btn btn-primary btn-primary--md btn-block mt-0"
      (click)="fnCloseDuplicateTransactionsPanel()">
      {{ "ok_got_it" | translate }}
    </button>
  </div>
</div>

<!-- Host for the Imported Transactions panel opened by "View" above. Sits after
     the duplicate panel so the created panel stacks on top of it — both use the
     same z-index, so DOM order decides. -->
<ng-container #importedTransactionsHost></ng-container>

<app-alert-panel [data]="alertPanelModelForDuplicateFile"
  (callbackEvent)="closeAlertPanelForDuplicateFile($event)"></app-alert-panel>